import React from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue } from 'recoil'

import {
  Icon60PaperPlane,
  Panel,
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_BOLD_LIGHT,
  TEXT_VARIANT_SMALL_LIGHT
} from 'mailup-web-components'

import styled from '@emotion/styled'

import { timelineEmptyState } from 'Pages/ScheduledSendings/recoil/state/calendar'

const StyledIcon = styled(Icon60PaperPlane)`
  color: lightgray;
  font-size: 34px;
`

const StyledText = styled(Text)`
  text-align: center;
`

const TimelineEmptyState = () => {
  const intl = useIntl()
  const isEmptyState = useRecoilValue(timelineEmptyState)

  return isEmptyState ? (
    <>
      <Panel>
        <Flex
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
        >
          <FlexItem margin='0 0 4px 0'>
            <StyledIcon />
          </FlexItem>
          <Text variant={TEXT_VARIANT_BOLD_LIGHT}>
            {intl.formatMessage({
              id: 'Load.ScheduledMailing.NoSchedulationTitle'
            })}
          </Text>
          <StyledText variant={TEXT_VARIANT_SMALL_LIGHT}>
            {intl.formatMessage({
              id: 'Load.ScheduledMailing.NoSchedulationText'
            })}
          </StyledText>
        </Flex>
      </Panel>
    </>
  ) : null
}

export default TimelineEmptyState
